function sortByDate(arr, replace = false) {
  replace && arr.sort((a, b) => Date.parse(a.datetime.replace(/-/g, '/')) < Date.parse(b.datetime.replace(/-/g, '/')) ? 1 : -1);
  !replace && arr.sort((a, b) => Date.parse(a.datetime) < Date.parse(b.datetime) ? 1 : -1);
  return arr
}

export default sortByDate